import i18n from 'i18n-js';
import { hours_by_frame } from 'constants/pricing';
import { round } from 'utils';

const TimeFrameCalculation = ({ selected_timeframe, distance_allowance, units }) => {
  const getTotalIncludedUnits = (time) => {
    const included = distance_allowance;
    if (included <= 0) return 0;
    const total = round((included * hours_by_frame[time]) / hours_by_frame[selected_timeframe], 0);
    return new Intl.NumberFormat('en-US').format(total);
  };
  const renderedTimeframes = [];

  if (selected_timeframe !== 'hourly') {
    renderedTimeframes.push(
      ` ${getTotalIncludedUnits('hourly')} ${i18n.t('ruleset.units_per_hour', {
        units: units?.total || '',
      })}`
    );
  }

  if (selected_timeframe !== 'daily') {
    renderedTimeframes.push(
      ` ${getTotalIncludedUnits('daily')} ${i18n.t('ruleset.units_per_day', {
        units: units?.total || '',
      })}`
    );
  }

  if (selected_timeframe !== 'weekly') {
    renderedTimeframes.push(
      ` ${getTotalIncludedUnits('weekly')} ${i18n.t('ruleset.units_per_week', {
        units: units?.total || '',
      })}`
    );
  }

  if (selected_timeframe !== 'monthly') {
    renderedTimeframes.push(
      ` ${getTotalIncludedUnits('monthly')} ${i18n.t('ruleset.units_per_month', {
        units: units?.total || '',
      })}`
    );
  }

  return (
    <>
      {`${i18n.t('ruleset.equal_to')} `}
      {renderedTimeframes.map((renderedTimeframe, index) => (
        <>
          {index !== 0 ? ' /' : ''}
          {renderedTimeframe}
        </>
      ))}
    </>
  );
};

export { TimeFrameCalculation };
